import { gql } from "@apollo/client"
import { CreateEmployerOfRecordInput, CreateEmployerOfRecordPayload } from "@oysterhr/schema"

import { useMutation, InjectedOptions } from "@oysterhr/core"

const MUTATION = gql`
  mutation CreateEmployerOfRecord(
    $name: String!
    $contactEmail: String
    $contactName: String
    $financeEmail: String
    $notes: String
    $cutOffMonthDay: Int!
    $externalToolsAttributes: [ExternalToolInputType!]
    $employerOfRecordDetailAttributes: EmployerOfRecordDetailsAttributesInput
    $employerOfRecordCountryId: String
    $direct: Boolean
    $entityType: GlobalPayrollEorEntityTypeEnum
    $position: Int
    $employerOfRecordCountryByAlpha2: String
  ) {
    createEmployerOfRecord(
      input: {
        name: $name
        contactEmail: $contactEmail
        contactName: $contactName
        financeEmail: $financeEmail
        notes: $notes
        cutOffMonthDay: $cutOffMonthDay
        externalToolsAttributes: $externalToolsAttributes
        employerOfRecordDetailAttributes: $employerOfRecordDetailAttributes
        employerOfRecordCountryId: $employerOfRecordCountryId
        direct: $direct
        entityType: $entityType
        position: $position
        employerOfRecordCountryByAlpha2: $employerOfRecordCountryByAlpha2
      }
    ) {
      employerOfRecord {
        id
        name
        contactEmail
        contactName
        financeEmail
        notes
        isDeletable
        cutOffMonthDay
        cutOffMonthDayIsSet
        employerOfRecordCountry {
          alpha2
        }
      }
      errors
    }
  }
`

export type CreateEmployerOfRecordPayloadType = {
  createEmployerOfRecord: CreateEmployerOfRecordPayload
}

export const useCreateEmployerOfRecord = (
  options?: InjectedOptions<CreateEmployerOfRecordPayloadType, CreateEmployerOfRecordInput>,
) => useMutation(MUTATION, options)
